import { Injectable } from '@angular/core';

@Injectable()
export class LoadingStateService {
    isLoading: boolean;
    isLoadingEnabled: boolean = true;

    constructor() { }
}